import { render } from "./ExchangeCard.vue?vue&type=template&id=61eb44fa&ts=true"
import script from "./ExchangeCard.vue?vue&type=script&lang=ts"
export * from "./ExchangeCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__